// extracted by mini-css-extract-plugin
export default {"add":"DocumentColumnList_add__v6+6U","table":"DocumentColumnList_table__c1kOk","add-container":"DocumentColumnList_add-container__dVPhT"};